import { useState, useEffect } from 'react'
import { Column, Row } from 'src/shared/components/Semantic/all'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from 'src/shared/components/ui/dialog'
import { Button } from 'src/shared/components/ui/button'
import { Input } from 'src/shared/components/ui/input'
import { useLocalization } from 'src/shared/hooks/useLocalization'

export const UpdateQuantityDialog = ({
  open,
  onOpenChange,
  initialQuantity,
  moq = 1,
  onContinue,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  initialQuantity: number
  moq?: number
  onContinue: (quantity: number) => Promise<void>
}) => {
  const { t } = useLocalization()
  const [quantity, setQuantity] = useState(initialQuantity)
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    if (open) {
      setQuantity(initialQuantity)
    }
  }, [open, initialQuantity])

  const handleContinue = async () => {
    const qty = Math.max(moq, Math.floor(quantity) || 1)
    setIsSubmitting(true)
    try {
      await onContinue(qty)
      onOpenChange(false)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>
            {t('Update quantity?', 'Uppdatera antal?')}
          </DialogTitle>
          <DialogDescription>
            {t(
              'Quantity affects decoration suggestions. Would you like to update the quantity before adding a decoration?',
              'Antal påverkar dekorationförslag. Vill du uppdatera antalet innan du lägger till en dekoration?'
            )}
          </DialogDescription>
        </DialogHeader>

        <Column className="gap-4 py-2">
          <Input
            id="quantity-input"
            label={t('Quantity', 'Antal')}
            type="number"
            min={moq}
            value={quantity}
            onChange={(e) =>
              setQuantity(Math.max(moq, Number(e.target.value) || moq))
            }
          />
        </Column>

        <DialogFooter>
          <Button
            variant="secondary"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            {t('Cancel', 'Avbryt')}
          </Button>
          <Button onClick={handleContinue} disabled={isSubmitting}>
            {t('Continue', 'Fortsätt')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
